import { NOTIFICATIONS } from '@perpay-web/fintech/constants/tableNames';
import { NotificationType } from '@perpay-web/fintech/reducers/entities/notifications';
import { RootState } from '@perpay-web/fintech/store';

export const getUnacknowledgedNotifications = (state: RootState) => {
    const notifications = Object.values(state.entities[NOTIFICATIONS]);
    return notifications.filter((notification) => !notification.acknowledged);
};

export const isNotificationPhoExistingUser = (state: RootState) => {
    const notifications = Object.values(state.entities[NOTIFICATIONS]);
    if (notifications.length) {
        return notifications[0].type === NotificationType.PHO_EXISTING_USER;
    }

    return false;
};
